export const performancereview_French= 
{
  "id": 0,
  "name": "Examen de performance",
  "prompts": [
    {
      "id": 1,
      "who": "Tâche",
      "what": "Rédiger une évaluation de performance."
    },
    {
      "id": 2,
      "who": "Nom",
      "what": "Eric"
    },
    {
      "id": 3,
      "who": "Titre",
      "what": "Développeur logiciel junior"
    },
    {
      "id": 4,
      "who": "Échéances",
      "what": "Les respecte très souvent. Son code est exempt de bugs."
    },
    {
      "id": 5,
      "who": "Membre de l'équipe",
      "what": "Participe bien."
    }
  ]
}


    export const floridaoranges_French= 
    {
      "id": 0,
      "name": "Oranges de Floride",
      "prompts": [
        {
          "id": 1,
          "who": "Rapport trimestriel: Production d'oranges en Floride",
          "what": "Trimestre: janvier - mars"
        },
        {
          "id": 2,
          "who": "1. Aperçu:",
          "what": "production totale, conditions météorologiques, défis rencontrés et projections futures pour l'industrie de l'orange dans l'État"
        },
        {
          "id": 3,
          "who": "2. Production totale d'oranges",
          "what": "Total de 2,5 millions de caisses. Augmentation de 10% de la production par rapport à la même période l'année dernière."
        },
        {
          "id": 4,
          "who": "3. Conditions météorologiques:",
          "what": "Températures modérées, avec des précipitations adéquates. Des fronts froids occasionnels et des épisodes de gel ont été observés."
        },
        {
          "id": 5,
          "who": "4. Défis rencontrés:",
          "what": "Menace persistante de maladies des agrumes, en particulier le dépérissement des agrumes. Pénurie de main-d'œuvre. Augmentation du coût de production."
        },
        {
          "id": 6,
          "who": "5. Demande du marché et exportations:",
          "what": "Intérêt stable au cours du premier trimestre, tant sur le marché national qu'international. Ventes accrues : Europe, Canada."
        },
        {
          "id": 7,
          "who": "6. Projections futures:",
          "what": "Production prévue pour rester stable. Mise en œuvre de stratégies de gestion des maladies. Surveillance étroite de la météo."
        },
        {
          "id": 8,
          "who": "7. Conclusion:",
          "what": "Rédigez un rapport basé sur les faits mentionnés ci-dessus. Utilisez les mêmes en-têtes."
        }
  
      ]
    }

    export const email_French= 
    {
      "id": 0,
      "name": "Email",
      "prompts": [
        {
          "id": 1,
          "who": "À qui :",
          "what": "John Smith"
        },
        {
          "id": 2,
          "who": "Objet : Conférence sur les panneaux solaires",
          "what": "Planification d'un voyage à Hawaii pour la conférence annuelle sur les panneaux solaires."
        },
        {
          "id": 3,
          "who": "Date :",
          "what": "25-29 septembre"
        },
        {
          "id": 4,
          "who": "Cordialement :",
          "what": "Mike Thomson"
        },
        {
          "id": 5,
          "who": "Tâche :",
          "what": "Écrire un email."
        }
      ]
    }

    export const travelexpense_French= 
    {
      "id": 0,
      "name": "Frais de voyage",
      "prompts": [
        {
          id: 1,
          who: 'Titre:',
          what: 'Afficher ceci en tant qu\'en-tête: Voyage à New York - frais de voyage'
        },
        {
          id: 2,
          who: 'Transport:',
          what: 'Billet d\'avion: 560 $.\nFrais de taxi: 156 $'
        },
        {
          id: 3,
          who: 'Hébergement:',
          what: 'Hôtel - 2 nuits: 350 $'
        },
        {
          id: 4,
          who: 'Repas:',
          what: 'Petit-déjeuner: 56 $\nDéjeuner: 78 $\nDîner: 126 $\nCollations: 13 $'
        },
        {
          id: 5,
          who: 'Tâche:',
          what: 'Listez toutes les dépenses sur une ligne séparée.\nÀ la fin, indiquez le total.'
        }
        
      ]
    }